import React from 'react';
import { PropTypes } from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import { ProductCard } from '../productCard';
import { Spinner } from '../../components';

import { productTypes } from '../../types/products';

const GridwallProducts = ({ products, loadProducts, handleProductClick, hasMore }) => {
  const productList = products.map((prod, idx) => (
    // eslint-disable-next-line
    <ProductCard {...prod} key={`${prod.styleNumber}-${idx}`} handleProductClick={handleProductClick} />
  ));
  return (
    <InfiniteScroll
      element='ul'
      className='gridwall__cardList flex-container row wrap mt4-sm'
      pageStart={0}
      loadMore={loadProducts}
      hasMore={hasMore}
      loader={
        <div key={0} className='flex-container center u-full-width' style={{ height: '40px', position: 'relative' }}>
          <Spinner />
        </div>
      }
      initialLoad={false}
      threshold={2500}
    >
      {productList}
    </InfiniteScroll>
  );
};

GridwallProducts.propTypes = {
  products: PropTypes.arrayOf(productTypes).isRequired,
  loadProducts: PropTypes.func.isRequired,
  handleProductClick: PropTypes.func.isRequired,
  hasMore: PropTypes.bool
};

GridwallProducts.defaultProps = {
  hasMore: true
};

export default GridwallProducts;
